import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQ = () => {
  const [openItems, setOpenItems] = useState(new Set([0]));

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems?.has(index)) {
      newOpenItems?.delete(index);
    } else {
      newOpenItems?.add(index);
    }
    setOpenItems(newOpenItems);
  };

  const faqData = [
    {
      category: "Acheteurs Locaux",
      questions: [
        {
          question: "Combien de temps prend une transaction immobilière complète ?",
          answer: `Une transaction immobilière complète prend généralement entre 30 à 60 jours ouvrables, selon la complexité du dossier.\n\nLes étapes principales incluent :\n- Vérification des documents (5-7 jours)\n- Négociation et signature du compromis (3-5 jours)\n- Obtention du financement si nécessaire (15-30 jours)\n- Signature définitive chez le notaire (1 jour)\n\nNotre équipe vous accompagne à chaque étape pour accélérer le processus.`
        },
        {
          question: "Quels sont les frais cachés à prévoir lors d'un achat ?",
          answer: `Au-delà du prix d'achat, prévoyez :\n- Frais de notaire : 2-3% du prix de vente\n- Droits d'enregistrement : 5% de la valeur\n- Frais d'expertise : 50,000 - 100,000 XOF\n- Assurance habitation : variable selon le bien\n- Frais de raccordement aux services publics si nécessaire\n\nNous fournissons une estimation détaillée avant chaque transaction.`
        }
      ]
    },
    {
      category: "Investisseurs Diaspora",
      questions: [
        {
          question: "Comment acheter un bien depuis l'étranger en toute sécurité ?",
          answer: `L'achat à distance est possible grâce à nos services sécurisés :\n\n1. Visite virtuelle complète avec vidéos HD\n2. Vérification indépendante par nos experts\n3. Procuration notariée pour la signature\n4. Transfert bancaire sécurisé avec garanties\n5. Suivi en temps réel de toutes les étapes\n\nNotre représentant local peut agir en votre nom pour toutes les démarches administratives.`
        },
        {
          question: "Quelles garanties avez-vous pour les investisseurs internationaux ?",
          answer: `Nous offrons plusieurs niveaux de protection :\n- Assurance transaction jusqu'à 50 millions XOF\n- Vérification juridique complète par notaires partenaires\n- Garantie de remboursement en cas de vice caché\n- Service client dédié aux investisseurs internationaux\n- Suivi post-achat pendant 12 mois\n\nTous nos partenaires sont certifiés et régulièrement audités.`
        }
      ]
    },
    {
      category: "Aspects Juridiques",
      questions: [
        {
          question: "Que faire en cas de litige avec un vendeur ?",
          answer: `En cas de litige, plusieurs recours sont possibles :\n\n1. Médiation amiable avec notre équipe juridique\n2. Recours aux tribunaux civils compétents\n3. Activation des garanties d'assurance si applicable\n4. Accompagnement par nos avocats partenaires\n\nLa plupart des litiges (85%) sont résolus par médiation dans les 30 jours.`
        },
        {
          question: "Comment vérifier la légalité d'un titre de propriété ?",
          answer: `La vérification comprend plusieurs étapes :\n- Contrôle au Registre Foncier Urbain\n- Vérification cadastrale et topographique\n- Enquête de voisinage et de moralité\n- Validation par un géomètre expert\n- Certification notariale finale\n\nCette vérification est incluse dans tous nos services et prend 5-7 jours ouvrables.`
        }
      ]
    }
  ];

  return (
    <section className="py-24 bg-transparent border-none outline-none relative z-10">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-heading font-bold text-white mb-6 tracking-tight">
            Questions Fréquentes
          </h2>
          <p className="text-lg text-white/50 max-w-2xl mx-auto font-light leading-relaxed">
            Trouvez des réponses claires aux questions les plus courantes sur nos services juridiques et processus d'acquisition.
          </p>
        </div>

        {/* FAQ Accordions */}
        <div className="space-y-12">
          {faqData?.map((category, categoryIndex) => (
            <div key={categoryIndex} className="bg-[#111111] rounded-3xl shadow-2xl overflow-hidden border-none outline-none">
              
              {/* Category Header */}
              <div className="p-8 bg-white/[0.02] border-b border-white/5">
                <h3 className="text-xl font-heading font-bold text-white flex items-center gap-4 tracking-tight">
                  <div className="w-10 h-10 rounded-xl bg-brand-gold/10 flex items-center justify-center shadow-inner">
                    <Icon 
                      name={categoryIndex === 0 ? "Home" : categoryIndex === 1 ? "Globe" : "Scale"} 
                      size={20} 
                      className="text-brand-gold" 
                    />
                  </div>
                  {category?.category}
                </h3>
              </div>

              {/* Questions List */}
              <div className="p-2">
                {category?.questions?.map((item, questionIndex) => {
                  const globalIndex = categoryIndex * 10 + questionIndex;
                  const isOpen = openItems?.has(globalIndex);
                  
                  return (
                    <div key={questionIndex} className="mb-2 last:mb-0">
                      <button
                        onClick={() => toggleItem(globalIndex)}
                        className={`w-full px-6 py-5 text-left transition-all duration-300 rounded-2xl border-none outline-none flex items-center justify-between group ${
                          isOpen ? 'bg-white/5' : 'hover:bg-white/[0.02]'
                        }`}
                      >
                        <h4 className={`text-base font-bold pr-4 transition-colors ${isOpen ? 'text-brand-gold' : 'text-white group-hover:text-gray-300'}`}>
                          {item?.question}
                        </h4>
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 bg-brand-gold/10 text-brand-gold' : 'bg-white/5 text-white/50 group-hover:text-white group-hover:bg-white/10'}`}>
                          <Icon
                            name="ChevronDown"
                            size={18}
                          />
                        </div>
                      </button>
                      
                      {isOpen && (
                        <div className="px-6 pb-6 pt-2 animate-slide-up">
                          <div className="border-l-2 border-brand-gold/50 pl-6 ml-2">
                            {item?.answer?.split('\n\n')?.map((paragraph, pIndex) => (
                              <div key={pIndex}>
                                {paragraph?.includes('- ') || paragraph?.includes('1. ') ? (
                                  <ul className="space-y-3 text-white/60 leading-relaxed mb-4 font-light">
                                    {paragraph?.split('\n')?.filter(line => line?.trim())?.map((line, lIndex) => (
                                      <li key={lIndex} className="flex items-start gap-3">
                                        {line?.startsWith('- ') || /^\d+\./.test(line) ? (
                                          <>
                                            <div className="w-5 h-5 rounded-full bg-emerald-500/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                                              <Icon name="Check" size={12} className="text-emerald-400" />
                                            </div>
                                            <span>{line?.replace(/^- |^\d+\.\s/, '')}</span>
                                          </>
                                        ) : (
                                          <span className="font-bold text-white mb-2 block">{line}</span>
                                        )}
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <p className="text-white/60 font-light leading-relaxed mb-4 last:mb-0">
                                    {paragraph}
                                  </p>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Contact Support Block */}
        <div className="mt-16 bg-gradient-to-br from-[#111111] to-[#0A0A0A] rounded-3xl p-10 md:p-12 text-center shadow-2xl border-none relative overflow-hidden group">
          {/* Subtle glow */}
          <div className="absolute inset-0 bg-brand-gold/5 opacity-50 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none blur-3xl rounded-full" />
          
          <div className="relative z-10">
            <div className="w-16 h-16 bg-white/5 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-inner">
              <Icon name="MessageCircle" size={32} className="text-white" />
            </div>
            <h3 className="text-2xl font-heading font-bold text-white mb-4 tracking-tight">
              Besoin d'une assistance personnalisée ?
            </h3>
            <p className="text-white/50 font-light mb-8 max-w-2xl mx-auto leading-relaxed">
              Notre équipe d'experts juridiques est disponible pour répondre à vos questions spécifiques 
              et vous accompagner dans vos démarches immobilières.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <div className="flex items-center justify-center gap-3 bg-white/5 px-6 py-3 rounded-full">
                <Icon name="Phone" size={18} className="text-brand-gold" />
                <span className="font-bold text-white">+225 21 50 00 53 18</span>
              </div>
              <div className="flex items-center justify-center gap-3 bg-white/5 px-6 py-3 rounded-full">
                <Icon name="Mail" size={18} className="text-brand-gold" />
                <span className="font-bold text-white">contact@kapitalstates.com</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FAQ;